<template>
    <section
        class="start-cta container container--only-desktop"
        :class="{
            'start-cta--footer': footer,
        }"
        :style="{...generateStylingVariables(content.style)}"
    >
        <div class="start-cta__inner">
            <zoe-atom-text
                v-if="stringIsNotEmpty(content.text.value)"
                class="start-cta__text"
                :item="content.text.value"
            />

            <div
                v-if="stringIsNotEmpty(content.time.text.value)"
                class="start-cta__time"
            >
                <zoe-atom-text
                    class="start-cta__time-text"
                    :item="content.time.text.value"
                />

                <zoe-atom-media
                    class="start-cta__icon"
                    :item="content.time.icon.value"
                />
            </div>

            <div class="start-cta__items">
                <button
                    v-for="(item, index) in content.items"
                    :key="index"
                    class="button start-cta__button"
                    :value="item.variable?.value"
                    @click="buttonClick"
                >
                    <zoe-atom-text
                        class="label"
                        :item="item.button.value"
                    />
                </button>
            </div>

            <div
                v-if="stringIsNotEmpty(content.disclaimer.text.value)"
                class="start-cta__disclaimer"
            >
                <zoe-atom-media
                    class="start-cta__icon"
                    :item="content.disclaimer.icon.value"
                />

                <zoe-atom-text
                    class="start-cta__disclaimer-text"
                    :item="content.disclaimer.text.value"
                />
            </div>
        </div>
    </section>
</template>

<script>
import ZoeAtomText from '../../../../../../resources/components/atoms/text/v1.0.0/zoe-atom-text.vue';
import ZoeAtomMedia from '../../../../../../resources/components/atoms/media/v1.0.0/zoe-atom-media.vue';
import Component from '../../../../../../resources/mixins/component/component.vue';
import Step from '../../../../../../resources/mixins/step/step.vue';
import scrollToSelector from '../../../../../../resources/mixins/utils/scroll-to-selector';
import { generateStylingVariables } from '../../../../../../resources/mixins/styling/styling';

export default {
    components: { ZoeAtomText, ZoeAtomMedia },
    mixins: [Component, Step],

    props: {
        step: {
            type: String,
            required: true,
        },
        footer: {
            type: Boolean,
            default: false,
        },
        showValue: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        generateStylingVariables,
        saveProperties() {
            this.$store.commit('component/setOrganismValue', {
                component: 'startCta',
                object: { isActive: true },
            });
        },

        buttonClick(event) {
            const enableOverlay = this.getValue(`${this.step}.overlay.enable`);

            if (!enableOverlay) {
                const scrollOffset = this.getValue('general.logobar.position') === 'fixed' ? -160 : -60;

                if (this.footer && this.showValue === false) {
                    scrollToSelector('.step__flow', scrollOffset);
                } else {
                    scrollToSelector('.step__flow', scrollOffset, () => {
                        this.goToNextStep();
                    });
                }
            } else {
                if (this.footer && !this.showValue) {
                    this.$emit('handleButtonClick');
                    return;
                }

                this.goToNextStep();
                this.$emit('handleButtonClick');
            }

            this.$store.commit('page/setVariable', {
                key: 'start-cta-button',
                value: event.target.value,
            });
        },
    },

    mounted() {
        if (this.content.show.value) {
            this.saveProperties();
        }
    },
};
</script>

<style lang="scss">
@use 'step-start-cta';

.start-cta {
    --background: v-bind('content.style.background.value');
    --column-count-mobile: v-bind('content.columnCountOnMobile.value');
    --column-count-desktop: v-bind('content.columnCount.value');
}
</style>
